import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import "./BackToTop.scss";

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const rootEl = document.getElementById("root");
    if (!rootEl) return;

    const toggleVisibility = () => {
      if (rootEl.scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    rootEl.addEventListener("scroll", toggleVisibility);
    // Initial check in case it's already scrolled
    toggleVisibility();

    return () => rootEl.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    const rootEl = document.getElementById("root");
    if (rootEl) {
      rootEl.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <button
      type="button"
      className={`back-to-top ${isVisible ? "visible" : ""} ${isHome ? "is-home" : ""}`}
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <ArrowUp size={20} strokeWidth={2.5} />
    </button>
  );
};

export default BackToTop;
